// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__BpOQk","img":"styles_img__16Osw"};